import { stringToDate } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'
import { Model } from 'modules/core/lib/mobx-rest'

import Compensation from 'modules/contracts/store/models/Compensation'

export interface ICompensationChange {
  id: number
  compensation_id?: number | null
  contract_version_id: number
  taxonomy_id: number
  compensation_type: string
  sync_with_supplements?: boolean
  recurrence_count?: number
  recurrence: string
  description?: string
  first_payment_on: string
  amount?: number
  is_deleted: boolean
  taxonomy_name: string
  original_compensation_id: number
  effective_at: string
  unit?: string
  starts_on?: string | null
  author?: string
}

export const COMPENSATION_CHANGE_IDS = {
  compensation_created: 'compensation_created',
  compensation_updated: 'compensation_updated',
  compensation_deleted: 'compensation_deleted',
}

const NONE_RECURRENT = 'none_recurrent'

class CompensationChange extends Model<ICompensationChange> {
  static urlRoot() {
    return '/bookkeepers_management/compensation_history'
  }

  get name() {
    return this.attributes.taxonomy_name
  }

  get type() {
    return Compensation.ItemTypes()[this.attributes.compensation_type]
  }

  get isDeleted() {
    return this.attributes.is_deleted
  }

  get hasCompensation() {
    return this.attributes.compensation_id !== null
  }

  get originalCompensationId(): number {
    return this.attributes.original_compensation_id
  }

  get effectiveAt() {
    return stringToDate(this.attributes.effective_at, 'backend_datetime')
  }

  translatedRecurrence() {
    return CompensationChange.translateRecurrence(
      this.attributes.recurrence,
      this.attributes.recurrence_count,
      this.attributes.sync_with_supplements
    )
  }

  static translateRecurrence(recurrence: string, count?: number, sync_with_supplements?: boolean) {
    if (sync_with_supplements) {
      if (!count) return null

      return i18n.tp(
        'contract_versions.forms.additional_compensation.modal.every_n_payroll_periods',
        { count }
      )
    }

    return Compensation.recurrences()[recurrence || NONE_RECURRENT]
  }
}

export default CompensationChange
